import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./GrantedPopup.module.css";
import { CDN_LINK } from "@globalConfig";
var GrantedPopup = function GrantedPopup() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.headSection
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/inspected-guaranteed-ar.svg",
    alt: t("inspected_guaranteed", {
      ns: "web_search"
    }),
    className: "m-hide"
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/garnteed-program.svg",
    alt: t("inspected_guaranteed", {
      ns: "web_search"
    }),
    className: "m-hide"
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/garntee-head-group.svg",
    alt: t("inspected_guaranteed", {
      ns: "web_search"
    }),
    className: "m-show"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.point
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/guarantee-10.svg",
    alt: "10-day guarantee icon"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, t("n_10_day_money_back_guarantee", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("p", null, t("reason_within_10_days_return", {
    ns: "web_search"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.point
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/shield.svg",
    alt: "Shield icon"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, tShort("allUspsModal/item_two_title")), /*#__PURE__*/React.createElement("p", null, tShort("allUspsModal/item_description")))), /*#__PURE__*/React.createElement("div", {
    className: stl.point
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/garnteee-check.svg",
    alt: "Inspection checkmark icon"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, t("inspection_200_points", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("p", null, t("inspect_used_cars_200_points", {
    ns: "web_search"
  })))));
};
export default GrantedPopup;